/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import axios from "axios";
import { Structure, StructureProperties } from 'molstar/lib/mol-model/structure';
import { WarningMessage, WarningMessagePlugin, JobMessage } from '../Utils.js'
import { PreLoad } from "./molstar_utils.js";
import { updateIsDetected } from './HookStateUpdate.jsx';

export const molstarToindeep = (plugin) => {
    const selections = Array.from(plugin.managers.structure.selection.entries.values());
    const chains = [];
    var chresdict = {};
    var count = 0;
    var namestructure;
    var message;
    for (const { structure } of selections) {
        if (!structure) continue;
        count += 1
        if (count > 1) {
            message = `Several selections on several structures, ${namestructure} is used`
            WarningMessagePlugin(plugin, message);
            continue
        };
        namestructure = structure.model.label;
        Structure.eachAtomicHierarchyElement(structure, {
            chain: loc => {
                chains.push(StructureProperties.chain.auth_asym_id(loc));
                if (!(StructureProperties.chain.auth_asym_id(loc) in chresdict)) {
                    chresdict[StructureProperties.chain.auth_asym_id(loc)] = []
                }
            },
            residue: loc => {
                chresdict[StructureProperties.chain.auth_asym_id(loc)].push(StructureProperties.residue.label_seq_id(loc))
            }
        });
    };
    var pymolselect = false;
    if (Object.keys(chresdict).length === 0) {
        count = 0;
        var structures = plugin.managers.structure.hierarchy.current.structures
        var structure
        for (var i = 0; i < structures.length; i++) {
            structure = structures[i];
            if (!structure) continue;
            count += 1
            if (count > 1) {
                message = `Several structures, ${namestructure} is used`
                WarningMessagePlugin(plugin, message);
                continue
            };
            namestructure = structure.model.cell.obj.data.label;
        }
    } else {
        pymolselect = {}
        for (const [k, v] of Object.entries(chresdict)) {
            var selectext = "";
            var listselect = [];
            var firstresi = v[0];
            for (var j = 0, jl = v.length; j < jl; ++j) {
                if (!(v[j] + 1 === v[j + 1])) {
                    selectext = `${firstresi}-${v[j]}`;
                    listselect.push(selectext);
                    firstresi = v[j + 1];
                }
            }
            pymolselect[k] = listselect
        }

    }
    return { 'namestructure': namestructure, 'pymolselect': pymolselect };
}

function formatselect(selectdict, typeselect) {
    var ch, res, select;

    if (typeselect === "structure") {
        select = '';
        for ([ch, res] of Object.entries(selectdict)) {
            select = select + ` chain ${ch} and resi ${res.join('+')}`;
        }
        select = `-s '${select}'`
    } else {
        var selectres = [];
        var chain = [];
        for ([ch, res] of Object.entries(selectdict)) {
            chain.push(ch);
            selectres.push(`${res.join('+')}`);
        }
        select = `--box 'resi ${selectres.join('+')}' --chain 'chain ${chain.join('+')}'`
    }
    
    return select
}

export const createJob = (plugin, namestructure, pymolselect, volume, email, useholo, parent_task_id) => {
    var structurestorage = JSON.parse(sessionStorage.getItem('structures'));
    var structureid = structurestorage[namestructure]['id'];
    var nametrajectory = Object.keys(structurestorage[namestructure]['trajectories'])[0];
    var trajectoryid = Object.keys(structurestorage[namestructure]['trajectories'])[0] ? structurestorage[namestructure]['trajectories'][nametrajectory]['id'] : false;
    var message;
    if (structurestorage[namestructure]['trajectories'].length > 1) {
        message = `Several trajectories, ${nametrajectory}, is used`;
        WarningMessagePlugin(plugin, message);
    }
    const formDataJob = new FormData();
    if (email === 'empty') {
        email = "";
    }
    var type = useholo ? "INDEEPHOLO" : "INDEEP";
    if (type === "INDEEPHOLO") {
        formDataJob.append("job_parent", parent_task_id);
    }
    formDataJob.append("type", type)
    formDataJob.append("email", email)
    formDataJob.append("structure", structureid);
    var typeselect;
    if (trajectoryid) {
        formDataJob.append("volume_pocket", volume);
        formDataJob.append("trajectory", trajectoryid);
        typeselect = "trajectory";
    } else {
        formDataJob.append("trajectory", "");
        formDataJob.append("volume_pocket", "");
        typeselect = "structure";
    };
    if (pymolselect) {
        formDataJob.append("select", formatselect(pymolselect, typeselect));
    } else {
        formDataJob.append("select", "");
    };
    try {
        axios({
            method: "post",
            url: "/api/job/",
            data: formDataJob,
            headers: { "Content-Type": "multipart/form-data" },
        }).then(
            async function (response) {
                if (!(response.data['status'] === 'SUCCESS') || useholo) {
                    var url = `${window.location.href.split('?')[0]}?job=${response.data['task_id']}`
                    if (useholo) {
                        JobMessage(`Your job has been submitted. You will receive an email when it is finished. You can consult this url to know its status or use the refresh button (see InDeepHolo results table)`, 'grey', url)

                    } else {
                        JobMessage(`Your job has been submitted. You will receive an email when it is finished. You can consult this url to know its status. `, 'grey', url)
                   }
                } else {
                    PreLoad(plugin, response.data['task_id'])
                    updateIsDetected(true);
                }
                
            }
        );
    } catch (error) {
        WarningMessage(error)
    }
}